import React from "react";
import PropTypes from "prop-types";

export default class FullTextSearch extends React.PureComponent{

    static propTypes = {
        language: PropTypes.string,
        searchString: PropTypes.string,
        onChange: PropTypes.func,
        onSubmit: PropTypes.func,
        onBlur: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <input
                type ="text"
                placeholder={window.Translator.getSlug('EnterKeywords', this.props.language)}
                value={this.props.searchString}
                onChange={this.props.onChange}
                onSubmit={this.props.onSubmit}
                onBlur={this.props.onBlur}
                className={"w-100"}
            />
        )
    }
}
